import React from 'react';
import {cloneDeep} from 'lodash';
import { ToastStore } from '../../../../components/ToastStore';

export default class RppPackageZones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      option1: null,
      option2: null,
      option3: null,
      geographyStatesSection: [],
      selectedZone: 1,
      stateError: null
    };
  }

  selectSingleState(selectedState, id) {
    let option1 = cloneDeep(this.state.option1);
    let option2 = cloneDeep(this.state.option2);
    let option3 = cloneDeep(this.state.option3);
    let stateError = cloneDeep(this.state.stateError);
    if (id === 1) {
      option1 = selectedState;
      option2 = null;
      option3 = null;
    } else if (id === 2) {
      option1 = null;
      option2 = selectedState;
    } else if (id === 3) {
      option1 = null;
      option3 = selectedState;
    }

    if (option2 !== null && option3 !== null) {
      if (option2 === option3) {
        stateError = 2;
        ToastStore.error('You cannot select the state you have previously selected');
      } else {
        stateError = null;
        this.props.onSelectingGeography([option2, option3], false);
        this.props.onGeographyClickAction();
      }
    } else if (option1 !== null) {
      stateError = null;
      this.props.onSelectingGeography([option1], false);
      this.props.onGeographyClickAction();
    }

    this.setState({
      option1: option1,
      option2: option2,
      option3: option3,
      stateError: stateError
    });
  }

  selectedGeographyState(geographyStatesSection, section, index, clickAction) {
    this.setState({
      selectedZone: section.id
    });
    if (section.id === 0) {
      this.props.onSelectingGeography(null, true);
      if (clickAction) {
        this.props.onGeographyClickAction();
      }
      this.setState({
        option1: null,
        option2: null,
        option3: null
      });
    }

    for (let subIndex = 0; subIndex < geographyStatesSection.length; subIndex++) {
      let price = section.total - geographyStatesSection[subIndex].total;
      if (price === 0) {
        geographyStatesSection[subIndex].price = 'Selected';
      } else if (price > 0) {
        geographyStatesSection[subIndex].price = `-$${Math.abs(price).toFixed(2)}`;
      } else if (price < 0) {
        geographyStatesSection[subIndex].price = `+$${Math.abs(price).toFixed(2)}`;
      }
    }

    this.setState({
      geographyStatesSection: geographyStatesSection
    });
  }

  componentDidMount() {
    let geographyStatesSection = [];
    let geographyStates = [];

    if (this.props.selectedPackage === 'trial') {
      geographyStatesSection.push({ id: 0, price: 'Included', state: 'Limited', total: 0 });
    } else {
      geographyStates = this.props.geography.states;

      //For more than 1 state. Set the states based on max and min possible states for the package
      if (
        this.props.geography.max_number_of_states >= 1 &&
        (this.props.geography.national_option || this.props.geography.national)
      ) {
        let statePrice;
        let objectSize = Object.keys(this.props.geography.base_price).length;
        for (let index = 0; index < objectSize; index++) {
          statePrice = Math.abs(
            this.props.packageBasePrice - this.props.geography.base_price[index]
          ).toFixed(2);
          if (
            parseInt(index, 10) === objectSize - 1 &&
            (this.props.geography.national_option || this.props.geography.national)
          ) {
            geographyStatesSection.push({
              id: 0,
              price: `+$${statePrice}`,
              state: 'National (All States/Territories)',
              total: this.props.geography.base_price[index]
            });
          } else {
            geographyStatesSection.push({
              id: parseInt(index, 10) + 1,
              price: `+$${statePrice}`,
              state: `${parseInt(index, 10) + 1} State/Territory`,
              total: this.props.geography.base_price[index]
            });
          }
        }
      } else if (
        this.props.geography.max_number_of_states === 1 ||
        this.props.geography.default_number_of_states === 1
      ) {
        geographyStatesSection.push({
          id: 1,
          price: 'Included',
          state: `${1} State/Territory`,
          total: this.props.geography.base_price
        });
      }

      //If only national option is available
      if (
        (this.props.geography.national_option || this.props.geography.national) &&
        this.props.geography.max_number_of_states === 0
      ) {
        this.props.onSelectingGeography(null, true);
        geographyStatesSection.push({
          id: 0,
          price: 'Included',
          state: 'National (All States/Territories)',
          total: this.props.geography.base_price
        });
      }
    }

    this.setState({
      geographyStatesSection: geographyStatesSection,
      geographyStates: geographyStates
    });

    if (
      this.props.selectedGeography.states !== null ||
      this.props.selectedGeography.national === true
    ) {
      let stateId = -1;
      let option1 = null,
        option2 = null,
        option3 = null;
      if (this.props.selectedGeography.national === true) {
        stateId = 0;
      } else {
        let numbOfStates = this.props.selectedGeography.states.length;
        if (numbOfStates === 1) {
          stateId = 1;
          option1 = this.props.selectedGeography.states[0];
        }
        if (numbOfStates === 2) {
          stateId = 2;
          option2 = this.props.selectedGeography.states[0];
          option3 = this.props.selectedGeography.states[1];
        }
      }

      for (let geoIndex = 0; geoIndex < geographyStatesSection.length; geoIndex++) {
        if (geographyStatesSection[geoIndex].id === stateId) {
          geographyStatesSection[geoIndex].total = parseFloat(
            geographyStatesSection[geoIndex].total
          );
          this.selectedGeographyState(
            geographyStatesSection,
            geographyStatesSection[geoIndex],
            geographyStatesSection[geoIndex].id,
            false
          );
        }
      }

      this.setState({
        option1: option1,
        option2: option2,
        option3: option3
      });
    }
  }

  render(props) {
    const legacySelectStyle = {
      border: '1px solid #a805fb',
      backgroundColor: '#f7efe2',
      color: 'midnightblue'
    };

    return (
      <div className='panel-body-spacing'>
        {this.state.geographyStatesSection.map(function (section, index) {
          let classNames = require('classnames');
          let zonesTileClass = classNames({
            'alert':
              section.id !== this.state.selectedZone || this.props.selectedPackage !== 'trial',
            'alert alert-success':
              (section.id === this.state.selectedZone && section.id !== this.state.stateError) ||
              this.props.selectedPackage === 'trial',
            'alert alert-danger': section.id === this.state.stateError
          });
          return (
            <div
              className={zonesTileClass}
              key={index}
              onClick={() => {
                this.selectedGeographyState(
                  this.state.geographyStatesSection,
                  section,
                  index,
                  true
                );
              }}
            >
              <div className='row no-margin zone-center body'>
                <div className='col-sm-6 no-padding'>{section.state}</div>
                <div className='col-sm-4 no-padding'>
                  {section.id === 1 && section.id === this.state.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='one-state-option1'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.state.option1 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.selectSingleState(event.target.value, 1);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.state.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                  {section.id === 2 && section.id === this.state.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='two-state-option1'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.state.option2 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.selectSingleState(event.target.value, 2);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.state.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                  {section.id === 2 && section.id === this.state.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='two-state-option2'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.state.option3 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.selectSingleState(event.target.value, 3);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.state.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                </div>
                <div className='col-sm-2 text-right no-padding'>
                  {section.price !== '+$0.00' && section.price !== 'Selected' && (
                    <span>{section.price}</span>
                  )}
                </div>
              </div>
            </div>
          );
        }, this)}
      </div>
    );
  }
}
